<script>
import Endpoints from '../../../components/common/Endpoints'
import Common from '../../../components/common/Common'
import Request from '../../../components/common/Request'
import { mapActions } from 'vuex'
import { stat } from 'fs'

export default {
    init: payload => {
        const el = document.body
        el.removeAttribute('class')
        $('.modal').modal('hide')
    },
    methods: {
        filter: function () {
            let state = this
            state.items = []
            $('#spinner').modal('toggle')

            if (!this.filters.status) {
                this.filters.status = 'ACTIVE'
            }
            
            setTimeout(() => {
                Request.do(
                    state,
                    'POST',
                    Request.getDefaultHeader(state),
                    this.filters,
                    `${Endpoints.companies.filter}`,
                    response => {
                        //SUCCESS CALLBACK
                        state.items = response.results[0].paginatedResults

                        $('#spinner').modal('toggle')
                    },
                    error => {
                        //ERROR CALLBACK
                        console.log(error)
                    },
                )
            }, 500)
        },
        onChange: function () {},
        getResultValue(result) {
            return `${result.fantasyName || ''} ${result.socialName} ${result.document}`
        },
        submitFilter: function (term) {
            
            if (!term) return            
            this.$emit('load-item', JSON.parse(JSON.stringify(term)));
            
            this.filters.name = `${term.fantasyName}|${term.socialName}|${term.document}`
            this.filter()
        },
        onChangeName: function (input) {
            let state = this

            this.filters.name = input
            if (input.length < 4) return []
            return new Promise((resolve, reject) => {
                Request.do(
                    state,
                    'GET',
                    Request.getDefaultHeader(state),
                    {},
                    `${Endpoints.companies.suggest}?term=${input}&status=${this.filters.status}&typeService=${this.filters.typeService}`,
                    response => {                        
                        resolve(response)
                    },
                    error => {
                        //ERROR CALLBACK
                        console.log(error)
                        reject(error)
                    },
                )
            })
        },
        onChangePage(pageOfItems) {
            // update page of items
            this.pageOfItems = pageOfItems
        },
        selectItem: function (item) {
            this.$emit('load-item', JSON.parse(JSON.stringify(item)))
        },
        getPageNumbers: function () {
            return this.items.length / 10
        },
        fetchData() {
            this.json_data = this.items
            return this.json_data
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    },
}
</script>
